import React, { useEffect } from 'react'

import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { CalendarEventForm } from './CalendarEventForm'
import AppLayout from '../common/AppLayout'
import AppTitle from '../common/AppTitle'

export const CalendarAddPage = () => {
    const {t} = useTranslation()

    useEffect(() => {

    }, [])

    return (
        <AppLayout>
            <AppTitle append={<Link to={'/app/calendar'}>
                <button className="btn amani-primary">{t('back')}</button>
            </Link>}>{t('new_event')}</AppTitle>
            <CalendarEventForm/>
        </AppLayout>
    )
}